import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth-guard';
import { loggedInGuard } from '@core/guards/logged-in.guard';


export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [loggedInGuard],
    loadChildren: () =>
      import('./pages/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
  },
  {
    path: 'decline-invitation',
    loadComponent: () => import('./pages/decline-invitation/decline-invitation.component').then(m => m.DeclineInvitationComponent)
  },
  {
    path: 'accept_invitation',
    loadComponent: () => import('./pages/accept-invitation/accept-invitation.component').then(m => m.AcceptInvitationComponent)
  },
  {
    path: 'reset-password',
    redirectTo: 'auth/reset-password',
    pathMatch: 'full'
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

];
